import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'react-bootstrap/lib/Modal';
import PrimaryButton from 'components/atoms/buttons/compact/Primary';
import SecondaryButton from 'components/atoms/buttons/compact/Secondary';
import styled from 'styled-components';
import { confirmable } from 'react-confirm';

const CancelButton = styled(SecondaryButton)`
    margin-left: 10px;
`;

class Confirmation extends React.Component {
    render() {
        const {
            okLabel = 'OK',
            cancelLabel = 'Cancel',
            title,
            confirmation,
            show,
            proceed,
            dismiss,
            cancel,
            enableEscape = true,
        } = this.props;
        return (
            <div className="static-modal">
                <Modal show={show} onHide={dismiss} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
                    <Modal.Header>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {confirmation}
                    </Modal.Body>
                    <Modal.Footer>
                        <PrimaryButton onClick={proceed}>{okLabel}</PrimaryButton>
                        <CancelButton onClick={cancel}>{cancelLabel}</CancelButton>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

Confirmation.propTypes = {
    okLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    title: PropTypes.string,
    confirmation: PropTypes.string,
    show: PropTypes.bool,
    proceed: PropTypes.func, // called when ok button is clicked.
    cancel: PropTypes.func, // called when cancel button is clicked.
    dismiss: PropTypes.func, // called when backdrop is clicked or escaped.
    enableEscape: PropTypes.bool,
};

export default confirmable(Confirmation);



// WEBPACK FOOTER //
// ./src/components/molecules/modal/Confirmation.js